import React from 'react';
import FormThemeReportsLogin from '~/auth/components/forms/FormThemeReportsLogin.jsx';

const PageThemeReportsLogin = () => (
  <div className="d-flex content-100">
    <div className="my-auto w-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 p-5 bg-white">
            <div className="text-center mb-3">
              <img className="logo" src={'assets/img/themeReports.svg'} />
            </div>
            {/* <h4 className="my-3 text-center">主題閱讀報告作品選</h4> */}
            <p className="text-center text-muted">此活動僅供老師登入帳戶進行作品提交</p>
            <div id="form-theme-reports-login">
              <FormThemeReportsLogin />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PageThemeReportsLogin;
